export const isCurrentRoute = (routePath: string): boolean => {
  const lastSegment = extractStep(window.location.pathname);

  return lastSegment === routePath;
};

export const extractStep = (url: string) => {
  const parts = url.split('/').filter(Boolean);
  return parts[parts.length - 1];
};
